class Hover
{

    constructor(){

        // ------------------------------ hover
        $('.hover').on('mouseenter', function() {
            const $this = $(this);
            $this.removeClass("is-hover");
            setTimeout(function() {
                $this.addClass("is-hover");
            }, 50);
        });

    }

    // ---------------------------------------------------------------------------------------------------------
}

export default Hover